import { EPermissoes } from '@/enums/ePermissoes';
import utlTipoFornecimentoService from '@/services/utilidade/utl-tipo-fornecimento.service';

export default [
  {
    description: 'Cadastro de Cerâmica',
    path: 'ceramica',
    name: 'ceramica',
    component: () => import('@/views/utilidade/produto/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.CadastroProduto],
      escopoObra: 'global'
    }
  },
  {
    description: 'Inclusão de Cerâmica',
    path: 'incluir',
    name: 'ceramicainsert',
    component: () => import('@/views/utilidade/produto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ceramica',
      utlTipoFornecimentoId: 101,
      campos: () => utlTipoFornecimentoService.getCamposProduto(101),
      permissions: [EPermissoes.CadastroProduto]
    }
  },
  {
    description: 'Inclusão de Cerâmica',
    path: 'incluir/:id',
    name: 'ceramicainsertcopy',
    component: () => import('@/views/utilidade/produto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ceramica',
      utlTipoFornecimentoId: 101,
      campos: () => utlTipoFornecimentoService.getCamposProduto(101),
      permissions: [EPermissoes.CadastroProduto]
    }
  },
  {
    description: 'Edição de Cerâmica',
    path: 'editar/:id',
    name: 'ceramicaupdate',
    component: () => import('@/views/utilidade/produto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ceramica',
      utlTipoFornecimentoId: 101,
      campos: () => utlTipoFornecimentoService.getCamposProduto(101),
      permissions: [EPermissoes.CadastroProduto]
    }
  },
  {
    description: 'Fornecedor de Cerâmica',
    path: 'fornecedor-obra',
    name: 'fornecedorobra-ceramica',
    component: () => import('@/views/gestao/fornecedor-obra/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Unidade de Cerâmica',
    path: 'unidade',
    name: 'unidadeceramica',
    component: () => import('@/views/gestao/unidade/Index.vue'),
    meta: {
      tipoFornecimento: 'ceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Unidade de Cerâmica',
    path: 'unidade/incluir',
    name: 'inclusaounidadeceramica',
    component: () => import('@/views/gestao/unidade/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'unidadeceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.CadastroObra]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Unidade Cerâmica',
    path: 'unidade/editar/:id',
    name: 'unidadeceramicaupdate',
    meta: {
      parentRouteName: 'unidadeceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.CadastroObra]
    },
    component: () => import('@/views/gestao/unidade/InclusaoEdicao.vue')
  },
  {
    description: 'Unidade Tipo Cerâmica',
    path: 'unidade-tipo',
    name: 'unidadetipoceramica',
    component: () => import('@/views/gestao/unidade-tipo/Index.vue'),
    goesToMenu: true,
    meta: {
      tipoFornecimento: 'ceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.CadastroObra],
      grupos: [],
      ambienteRouteName: 'ambienteceramica',
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Unidade Tipo Cerâmica',
    path: 'unidade-tipo/incluir',
    name: 'unidadetipoceramicainsert',
    component: () => import('@/views/gestao/unidade-tipo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'unidadetipoceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Unidade Tipo Cerâmica',
    path: 'unidade-tipo/editar/:id',
    name: 'unidadetipoceramicaupdate',
    meta: {
      parentRouteName: 'unidadetipoceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.CadastroObra]
    },
    component: () => import('@/views/gestao/unidade-tipo/InclusaoEdicao.vue')
  },
  {
    description: 'Local de Aplicação',
    path: 'ambiente/:gesUnidadeTipoId',
    name: 'ambienteceramica',
    component: () => import('@/views/gestao/ambiente/Index.vue'),
    goesToMenu: false,
    meta: {
      tipoFornecimento: 'ceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.CadastrosBase],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Local de Aplicação',
    path: 'ambiente/incluir/:gesUnidadeTipoId',
    name: 'ambienteceramicainsert',
    component: () => import('@/views/gestao/ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ambienteceramica',
      tipoFornecimento: 'ceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  },
  {
    description: 'Edição de Local de Aplicação',
    path: 'ambiente/editar/:gesUnidadeTipoId/:id',
    name: 'ambienteceramicaupdate',
    component: () => import('@/views/gestao/ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ambienteceramica',
      tipoFornecimento: 'ceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  },
  {
    description: 'Tipo Ensaio de Cerâmica',
    path: 'tipo-ensaio',
    name: 'tipoensaioceramica',
    component: () => import('@/views/utilidade/tipoensaio/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'global'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Tipo Ensaio Cerâmica',
    path: 'tipo-ensaio/incluir',
    name: 'tipoensaioceramicainsert',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'tipoensaioceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Tipo Ensaio Cerâmica',
    path: 'tipo-ensaio/editar/:id',
    name: 'tipoensaioceramicaupdate',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'tipoensaioceramica',
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.CadastroObra]
    }
  }
];
